import axios from "axios";

export const getAllRequest = async () => {
  const jwtToken = localStorage.getItem("token") || null;
  const response = await axios.get(
    "https://backend2.senarai-app.com/documents",
    {
      headers: {
        "Content-Type": "application/json",
        "Access-Control-Allow-Origin": "https://backend2.senarai-app.com",
        "Access-Control-Allow-Methods": "GET,PUT,POST,DELETE,PATCH,OPTIONS",
        Authorization: `Bearer ${jwtToken}`,
      },
    }
  );
  return response;
};

export const createRequest = async () => {
  const jwtToken = localStorage.getItem("token") || null;
  const response = await axios.post(
    "https://backend2.senarai-app.com/new-document",
    {
      content: "",
    },
    {
      headers: {
        "Content-Type": "application/json",
        "Access-Control-Allow-Origin": "https://backend2.senarai-app.com",
        "Access-Control-Allow-Methods": "GET,PUT,POST,DELETE,PATCH,OPTIONS",
        Authorization: `Bearer ${jwtToken}`,
      },
    }
  );
  return response;
};

export const deleteRequest = async (id) => {
  const jwtToken = localStorage.getItem("token") || null;
  const response = await axios.delete(
    `https://backend2.senarai-app.com/delete-document/${id}`,
    {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${jwtToken}`,
      },
    }
  );
  return response;
};


export const pinRequest = async (id) => {
  const jwtToken = localStorage.getItem("token") || null;
  const response = await axios.post(
    `https://backend2.senarai-app.com/pin-document/${id}`,
    {},
    {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${jwtToken}`,
      },
    }
  );
  return response;
};